module.exports = __webpack_public_path__ + "img/template-2-desktop.adb2d32c.png";